export const SectionHeader = (props: { title: string }) => (
  <div className='sticky top-0 bg-neutral-50 px-3 py-2 border-y border-neutral-200'>
    <h3 className='text-xs font-semibold text-neutral-800'>{props.title}</h3>
  </div>
);
